import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_CAFETERIA_GET_REGULATION } from "my-cafeteria/graphql";
import { OC_ASSETS_SUBSCRIPTION } from "oc/graphql";

export const useMyCafeteriaRegulation = () => {
  const { data, loading, error, refetch } = useQuery(
    MY_CAFETERIA_GET_REGULATION,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  useSubscription(OC_ASSETS_SUBSCRIPTION, {
    skip: !data,
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getVBKRegulation || "",
    loading,
    error,
    refetch,
  };
};

export default useMyCafeteriaRegulation;
